import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';
import { SideNavItem } from '../SideNavItem';
import { SideNavContext } from '../index.context';

const { StyledCollapsableNavItem, StyledContent } = Styles;

export const CollapsableNavItem = ({
    children,
    mobileNavItem,
    mobileOnly,
    icon,
    collapsibleSubNavItem,
    ...otherProps
}) => (
    <SideNavContext.Consumer>
        {({ mobile, collapsedMenu, setCollapsedMenu }) =>
            (mobile && (mobileNavItem || mobileOnly)) || !mobile ? (
                <InnerNavItem
                    mobile={mobile}
                    collapsedMenu={collapsedMenu}
                    setCollapsedMenu={setCollapsedMenu}
                    mobileNavItem={mobileNavItem}
                    mobileOnly={mobileOnly}
                    collapsibleSubNavItem={collapsibleSubNavItem}
                    icon={icon}
                    {...otherProps}
                >
                    {children}
                </InnerNavItem>
            ) : null
        }
    </SideNavContext.Consumer>
);

const InnerNavItem = ({
    id,
    title,
    selected,
    mobileNavItem,
    mobileOnly,
    defaultCollapsed,
    mobile,
    collapsedMenu,
    setCollapsedMenu,
    collapsibleSubNavItem,
    children,
    icon,
    ...otherProps
}) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    useEffect(() => {
        if (collapsedMenu) {
            setCollapsed(true);
        }
    }, [collapsedMenu]);

    return (
        <StyledCollapsableNavItem collapsed={collapsed} {...otherProps}>
            <SideNavItem
                id={id}
                icon={icon || 'chevron-right'}
                title={title}
                onClick={() => {
                    setCollapsed(!collapsed);
                    setCollapsedMenu(false);
                }}
                mobile={mobile}
                mobileNavItem={mobileNavItem}
                mobileOnly={mobileOnly}
                selectable={false}
                collapsibleSubNavItem={collapsibleSubNavItem}
            />
            <StyledContent collapsed={collapsed}>{children}</StyledContent>
        </StyledCollapsableNavItem>
    );
};

InnerNavItem.propTypes = {
    id: PropTypes.string,
    title: PropTypes.node,
    selected: PropTypes.string,
    mobileNavItem: PropTypes.bool,
    mobileOnly: PropTypes.bool,
    defaultCollapsed: PropTypes.bool,
    mobile: PropTypes.bool,
    collapsedMenu: PropTypes.bool,
    setCollapsedMenu: PropTypes.func,
    children: PropTypes.node.isRequired,
    collapsibleSubNavItem: PropTypes.bool,
    icon: PropTypes.string,
};

InnerNavItem.defaultProps = {
    id: '',
    title: '',
    selected: undefined,
    mobileNavItem: false,
    mobileOnly: false,
    defaultCollapsed: true,
    mobile: false,
    collapsedMenu: false,
    setCollapsedMenu: () => null,
    collapsibleSubNavItem: false,
    icon: undefined,
};

CollapsableNavItem.propTypes = {
    id: PropTypes.string,
    selected: PropTypes.string,
    title: PropTypes.node,
    mobileNavItem: PropTypes.bool,
    mobileOnly: PropTypes.bool,
    defaultCollapsed: PropTypes.bool,
    children: PropTypes.node.isRequired,
    collapsibleSubNavItem: PropTypes.bool,
    icon: PropTypes.string,
};

CollapsableNavItem.defaultProps = {
    id: '',
    title: '',
    selected: undefined,
    mobileNavItem: false,
    mobileOnly: false,
    defaultCollapsed: true,
    collapsibleSubNavItem: false,
    icon: undefined,
};

CollapsableNavItem.Styles = Styles;
